import { Box, useTheme } from "@mui/material";
import MainCard from "../../../../../../components/MainCard";
import { MdOutlineWorkOutline } from "react-icons/md";
import CompanyCard from "../../../../../../components/CompanyCard";

interface CompanyPackagesProps {
  companyId?: string;
}

const CompanyPackages: React.FC<CompanyPackagesProps> = ({ companyId }) => {
  const theme = useTheme();

  const cardLabels = [
    "Vacancies Packages",
    "Resume Packages",
    "All Vacancies",
    "Current Vacancies",
    "Pending Vacancies",
    "Valid Applications",
    "Unread Applications",
    "Expired Vacancies",
    "All Applications",
  ];

  return (
    <MainCard title="Company Packages">
      <Box sx={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
        {cardLabels.map((label) => (
          <CompanyCard
            key={label}
            icon={
              <MdOutlineWorkOutline
                style={{ color: "#fff", fontSize: "1.6rem" }}
              />
            }
            to={`/company-jobs/${companyId}`}
            label={label}
          />
        ))}
      </Box>
    </MainCard>
  );
};

export default CompanyPackages;
